import React, { useEffect, useState } from "react";
import { FaInstagram, FaTiktok, FaGlobe } from "react-icons/fa";
import { getAllboothsList, getCities, groupByCity } from "../../services/Booths";
import { useNavigate } from "react-router-dom";
import ls from "local-storage";
import { event } from "../../utils/gtag";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
function slugify(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

const socials = [
  {
    icon: <FaInstagram />,
    url: "https://instagram.com/sukhakala.id",
  },
  {
    icon: <FaTiktok />,
    url: "https://tiktok.com/@sukhakala.id",
  },
  {
    icon: <FaGlobe />,
    url: "https://sukhakala.id",
  },
];

export default function LocationsList() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const utmSource = params.get("utm_source");

  useEffect(() => {
    if (utmSource && window.gtag) {
      window.gtag("set", "user_properties", {
        utm_source: utmSource,
      });
    }
  }, [utmSource]);
  const [cityList, setCityList] = useState([]);
  function fetchboothsList() {
    getCities().then((response) => {
      setCityList(response.data);
    });
  }
  function fetchLS() {
    if (ls.get("userDetail")) {
      const userDetail = ls.get("userDetail");
    }
  }
  useEffect(() => {
    fetchboothsList();
    fetchLS();
  }, []);

  return (
    <>
      <Helmet>
        <title>Lokasi Booth Sukhakala Photobooth di Seluruh Indonesia</title>
        <meta
          name="description"
          content={`Daftar lokasi booth Sukhakala Photobooth di berbagai kota Indonesia: ${cityList
            .map((c) => c.name)
            .join(", ")}. Temukan photobooth terdekat di kota Anda!`}
        />
        <meta
          name="keywords"
          content={`sukhakala photobooth, lokasi sukhakala, photobooth ${cityList
            .map((c) => c.name)
            .join(", photobooth ")}, booth sukhakala, photobooth kota, photobooth event, photobooth partner`}
        />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-pink-50 flex flex-col items-center px-4 py-8">
        <img src="/latest-logo.jpg" alt="Sukhakala Logo" className="w-24 h-24 mb-4 rounded-full object-cover" />
        <h1 className="text-3xl font-bold text-center mb-2">Sukhakala Photobooth</h1>
        <p className="text-center text-gray-700 mb-4" style={{ display: "none" }}>
          Temukan lokasi photobooth Sukhakala di berbagai kota besar Indonesia. Klik kota untuk detail booth dan
          kolaborasi event!
        </p>
        Keeping memories alive with the new ✨love language✨
        <br />
        <br />
        {/* Social Icons */}
        <div className="flex space-x-4 mb-8">
          {socials.map((social, idx) => (
            <a
              key={idx}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                event({
                  action: "click_link",
                  category: "LocationsList",
                  label: social.url,
                })
              }
              className="text-2xl text-pink-600 hover:text-pink-800 transition"
            >
              {social.icon}
            </a>
          ))}
        </div>
        {/* Branch List */}
        <h2 className="text-xl font-semibold mt-2 mb-4">📍 Our Branches</h2>
        <div className="flex flex-col gap-4 w-full max-w-md">
          {cityList.length === 0 ? (
            <div className="text-gray-500">Loading branches...</div>
          ) : (
            cityList.map((city, cityIdx) => (
              <div className="flex flex-col gap-4" key={cityIdx}>
                <a
                  href={`/cities/${slugify(city.name)}-${city.id}`}
                  rel="noopener noreferrer"
                  className="bg-[#2b478e] text-white text-center py-3 px-6 rounded-xl shadow hover:bg-[#e7ac46] transition"
                  onClick={() =>
                    event({
                      action: "click_link",
                      category: "CitiesPage",
                      label: city.name,
                    })
                  }
                >
                  <span>📍 {city.name}</span>
                </a>
              </div>
            ))
          )}
        </div>
        {/* Hidden SEO keywords for Indonesian search */}
        <div style={{ display: "none" }}>
          sukhakala photobooth, lokasi sukhakala, booth sukhakala, photobooth kota, photobooth event, photobooth
          partner, photobooth {cityList.map((c) => slugify(c.name)).join(", photobooth ")}, lokasi photobooth{" "}
          {cityList.map((c) => slugify(c.name)).join(", lokasi photobooth ")}, sukhakala{" "}
          {cityList.map((c) => slugify(c.name)).join(", sukhakala ")}
        </div>
      </div>
    </>
  );
}
